<!--New design-->
<div class="container-fluid">
    <div class="col-md-12" *ngIf="isLoading">
        <app-busy [message]="message"></app-busy>
    </div>
    <div class="row">
        <!--    <div style="margin-top:15px; margin-bottom:-10px;">-->
        <!--      <h5><span style="padding-right:10px"></span> <i class="fa fa-edit"></i><b> Manage Return of permits</b></h5>-->
        <!--    </div>-->

        <div class="contact-details opensans-semi-bold-sapphire-30px">
            <span class="opensans-semi-bold-sapphire-30px">Manage return of permits</span>
        </div>
        <div class="rectangle-34"></div>
        <br/>

    </div>

    <form [formGroup]="form">

        <label>You can either</label>


        <div class="col-sm-4 ">
            <!--          <input type="radio" formControlName="btnRadio" [(ngModel)]="btnRadio"   name="btnRadio" value="A"/>-->
            <!--          <label>Scan QR code OR</label>-->

            <div class="form-check">
                <input class="form-check-input increasedcheckbox" type="radio" formControlName="btnRadio"
                       [(ngModel)]="btnRadio" name="btnRadio" value="A">
                <label class="form-check-label permitchecbox">
                    Scan QR code OR
                </label>
                <br/>
                <br/>
            </div>
        </div>
        <div class="col-sm-4">
            <!--          <input type="radio" formControlName="btnRadio" [(ngModel)]="btnRadio"    name="btnRadio" value="B"/>-->
            <!--          <label>Enter permit number and face value number</label>-->
            <div class="form-check">
                <input class="form-check-input increasedcheckbox" type="radio" formControlName="btnRadio"
                       [(ngModel)]="btnRadio" name="btnRadio" value="B">
                <label class="form-check-label permitchecbox">
                    Enter permit number and face value number
                </label>
                <br/>
                <br/>
            </div>
        </div>
        <div class="row" *ngIf="btnRadio=='A'">
            <div class="col-sm-4 ">
                <label><b>Under Construction</b></label>
            </div>
        </div>

        <div class="row" *ngIf="btnRadio=='B'">
            <div class="col-sm-4 ">
                <label>Permit number</label>
                <input formControlName="permit_num" class="form-control form-control-sm" type="text"/>
            </div>
            <div class="col-sm-4 ">
                <label>Face value number</label>
                <input formControlName="face_value" class="form-control form-control-sm" type="text"/>
            </div>
            <div class="col-sm-4">

                <label>Carrier Name</label>
                <div class="form-inline">
                    <input readonly style="width:70%;" formControlName="carrier_name"
                           class="form-control form-control-sm" type="text"/>
                    <!-- &nbsp;
                    <i class="text-success fa fa-search" (click)="search()" aria-hidden="true" ></i> -->
                    &nbsp;
                </div>
            </div>

            <ng-container *ngIf="this.permit?.document_guid !== null && this.permit?.document_guid !== undefined" class="mt-3 pt-2">
                <div class="col-md-12">
                    <br/>
                </div>
                <div class="col-sm-4 ">
                    <label>Change Status</label>

                    <select  [(ngModel)]="selected_perm_status_id"  formControlName="selected_perm_status_id" class="form-control select-auto" (change)="statusUpdate($event)"  id="selected_perm_status_id">
                        <option value="null">Select Status</option>
                        <ng-container *ngIf="perm_status_id<statusId">
                            <option *ngFor="let c of statuses" [ngValue]="c.id">
                                {{c.description}}
                            </option>
                        </ng-container>
                        <ng-container *ngIf="perm_status_id>=statusId">
                            <ng-container *ngFor="let c of statuses">
                                <option *ngIf="c.id>statusId" [ngValue]="c.id">
                                    {{c.description}}
                                </option>
                            </ng-container>
                        </ng-container>
                    </select>

                </div>
                <div class="col-sm-4 ">
                    Revoke digital certificate?
                    <input

                            class="form-control input-sm"
                            type="checkbox"
                            ([ngModel])="revoke_certificate"
                            id="should_revoke_certificate"
                            name="revoke_certificate"
                            (click)="revokeCertificate($event)"
                            formControlName="revoke_certificate"
                            [checked]="true"
                    />
                </div>

                <div class="col-sm-4" *ngIf="revoke_certificate">
                    Reason for revocation
                    <textarea
                            class="form-control input-sm"
                            type="text"
                            ([ngModel])="revoke_reason"
                            id="returnReason"
                            name="revoke_reason"
                            formControlName="revoke_reason"></textarea>
                </div>

            </ng-container>
            <div class="col-sm-12 text-center">
                <br/>
                <br/>
                <button class="btn hd-btn" (click)="confirm()"><i class="fa fa-check-square-o" aria-hidden="true"></i>
                   Get Permit Details
                </button>
                <button class="btn hd-btn" (click)="returnPermit()"><i class="fa fa-recycle" aria-hidden="true"></i>
                   {{button_label ?? 'Return Permit'}}
                </button>
            </div>

        </div>
    </form>

</div> <!--End new design -->
